import styled from '@emotion/styled'
import { Checkbox } from 'antd'

export const StyledCheckbox = styled(Checkbox)``
